(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "./cities", "../picker-time/picker-dialog", "../picker-time/picker-header", "../picker-time/picker-footer", "./pick-city"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("./cities"), require("../picker-time/picker-dialog"), require("../picker-time/picker-header"), require("../picker-time/picker-footer"), require("./pick-city"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.cities, global.pickerDialog, global.pickerHeader, global.pickerFooter, global.pickCity);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _cities, _pickerDialog, _pickerHeader, _pickerFooter, _pickCity) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _cities = _interopRequireDefault(_cities);
  _pickerDialog = _interopRequireDefault(_pickerDialog);
  _pickerHeader = _interopRequireDefault(_pickerHeader);
  _pickerFooter = _interopRequireDefault(_pickerFooter);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-picker-dialog', {
        staticClass: "dialog-modal",
        on: {
          "close": _vm.$_onClose
        }
      }, [_c('nx-picker-header', [_vm._v(_vm._s(_vm.title))]), _c('div', {
        ref: "boxContent",
        staticClass: "nx-box-content"
      }, _vm._l(_vm.format, function (elem, index) {
        return _c('div', {
          key: index,
          staticClass: "nx-adr-items"
        }, [_c('ul', {
          staticClass: "nx-adr-list"
        })]);
      }), 0), _c('nx-picker-footer', [_c('div', {
        on: {
          "click": _vm.$_onClose
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.leftBtn))])]), _c('div', {
        on: {
          "click": _vm.$_onConfirm
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.rightBtn))])])])], 1);
    },
    name: 'nx-picker-address',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _pickerHeader.default.name, _pickerHeader.default), (0, _defineProperty2.default)(_components, _pickerFooter.default.name, _pickerFooter.default), (0, _defineProperty2.default)(_components, _pickerDialog.default.name, _pickerDialog.default), _components),
    props: {
      title: {
        type: String,
        default: '选择地址'
      },
      leftBtn: {
        type: String,
        default: '取消'
      },
      rightBtn: {
        type: String,
        default: '确定'
      },
      list: {
        type: Array,
        default: function _default() {
          return _cities.default.areaList;
        }
      },
      currentPro: {
        type: String,
        default: '110000'
      },
      currentCity: {
        type: String,
        default: '110100'
      },
      currentArea: {
        type: String,
        default: '110101'
      },
      format: {
        type: Array,
        default: function _default() {
          return ['pro', 'city', 'area'];
        }
      }
    },
    data: function data() {
      return {
        city: {}
      };
    },
    mounted: function mounted() {
      this.$_initData();
      this.$nextTick(function () {
        var node = document.querySelector('.dialog-modal');
        node.addEventListener('touchmove', function (e) {
          e.stopPropagation();
          e.preventDefault();
        }, false);
      });
    },
    methods: {
      $_initData: function $_initData() {
        if (!this.currentPro && this.list && this.list[0].areaCode) {
          this.currentPro = this.list[0].areaCode;
        }

        var proNum = (0, _pickCity.findProIndex)(this.list, this.currentPro);

        if (!this.currentCity) {
          this.currentCity = this.list && this.list[proNum].areaList && this.list[proNum].areaList[0].areaCode ? this.list[proNum].areaList[0].areaCode : null;
        }

        var cityNum = this.currentCity ? (0, _pickCity.findProIndex)(this.list[proNum].areaList, this.currentCity) : 0;

        if (!this.currentArea) {
          this.currentArea = this.list && this.list[proNum].areaList && this.list[proNum].areaList[cityNum].areaList && this.list[proNum].areaList[cityNum].areaList[0].areaCode ? this.list[proNum].areaList[cityNum].areaList[0].areaCode : null;
        }

        this.$_onCitiesPicker();
      },
      $_onConfirm: function $_onConfirm() {
        var city = this.$_handleData(this.city);
        this.$emit('confirm', city);
      },
      $_onClose: function $_onClose() {
        this.$emit('close');
      },
      $_onCitiesPicker: function $_onCitiesPicker() {
        var options = {
          list: this.list,
          currentPro: this.currentPro,
          currentCity: this.currentCity,
          currentArea: this.currentArea
        };
        this.city = new _pickCity.selectCity(options, this.format, this.$refs.boxContent);
      },
      $_handleData: function $_handleData(val) {
        var key = {
          pro: {},
          city: {},
          area: {}
        };

        if (val.selectedPro != null) {
          key.pro.areaName = this.list[val.selectedPro].areaName;
          key.pro.areaCode = this.list[val.selectedPro].areaCode;

          if (val.selectedCity != null) {
            key.city.areaName = this.list[val.selectedPro].areaList[val.selectedCity].areaName;
            key.city.areaCode = this.list[val.selectedPro].areaList[val.selectedCity].areaCode;

            if (val.selectedArea != null) {
              key.area.areaName = this.list[val.selectedPro].areaList[val.selectedCity].areaList[val.selectedArea].areaName;
              key.area.areaCode = this.list[val.selectedPro].areaList[val.selectedCity].areaList[val.selectedArea].areaCode;
            }
          }
        }

        return key;
      }
    }
  };
  _exports.default = _default2;
});